import { EMAIL_SIGN_OFF } from '../../utils/emailSignOff';

export interface QuotationEmailDraftFacts {
  customerName?: string | null;
  quotationNumber: string;
  /** The page's answer (D104.12), never the quotation's own copy. */
  vesselName?: string | null;
}

/** The subject and text the send screen opens on (D180). What the person leaves there is what goes. */
export function quotationEmailDraft({ customerName, quotationNumber, vesselName }: QuotationEmailDraftFacts): { subject: string; body: string } {
  const vessel = vesselName?.trim();
  const forVessel = vessel ? ` for ${vessel}` : '';
  return {
    subject: `Quotation ${quotationNumber}${forVessel} — United Ship Chandlers`,
    body: `Dear ${customerName?.trim() || 'Sir/Madam'},\n\nPlease find attached our quotation ${quotationNumber}${forVessel}.\n\n${EMAIL_SIGN_OFF}`,
  };
}
